// extracted by mini-css-extract-plugin
export default {"input":"CustomersModule_input__erUad","actions":"CustomersModule_actions__3tvGp","table":"CustomersModule_table__B8J9t"};